import SolidSpinnerIcon from "../../../assets/icons/SolidSpinnerIcon";
import {
  createDashboardSectionAPI,
  fetchSectionsAPI,
} from "../../../api/dashboardApi";
import {
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuPortal,
  DropdownMenuSeparator,
  DropdownMenuSubContent,
} from "../../../components/ui/dropdown-menu";

import React, { useEffect, useState } from "react";
import PinDashboardDialog from "./PinDashboardDialog";
import PinDashboardSectionItem from "./PinDashboardSectionItem";
import { toast } from "../../../components/ui/use-toast";

const PinDashboardSection = ({ dashboardId, msgId }) => {
  const [isSectionLoading, setIsSectionLoading] = useState(true);
  const [sectionList, setSectionList] = useState([]);
  const [value, setValue] = useState("");
  const [isSectionCreationLoading, setIsSectionCreationLoading] =
    useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    await createDashboardSectionAPI({
      dashboardId,
      setIsLoading: setIsSectionCreationLoading,
      label: value,
    });
    setIsDialogOpen(false);
  };

  useEffect(() => {
    fetchSectionsAPI({
      dashboardId,
      setIsLoading: setIsSectionLoading,
      setError,
      setData: setSectionList,
    });
  }, [isDialogOpen]);

  if (error) {
    toast({
      title: "Fetching Sections",
      variant: "destructive",
      description: error,
    });
  }

  return (
    <>
      <DropdownMenuPortal>
        <DropdownMenuSubContent className="w-56 bg-zinc-900 border-zinc-800 text-zinc-100">
          <DropdownMenuLabel>Sections</DropdownMenuLabel>
          <DropdownMenuSeparator className="bg-zinc-800" />
          <DropdownMenuGroup
            className={`max-h-52 ${
              isSectionLoading ? "overflow-hidden" : "overflow-auto"
            }`}
          >
            {isSectionLoading ? (
              <div className="w-full h-full flex justify-center items-center">
                <SolidSpinnerIcon className="w-5 h-5 animate-spin" />
              </div>
            ) : sectionList.length !== 0 ? (
              sectionList.map((section, index) => {
                return (
                  <PinDashboardSectionItem
                    key={section.label + index}
                    label={section.label}
                    msgId={msgId}
                    dashboardId={dashboardId}
                    sectionId={index}
                  />
                );
              })
            ) : (
              <div className="text-zinc-300 text-center text-sm">
                No sections found
              </div>
            )}
          </DropdownMenuGroup>
          <DropdownMenuSeparator className="bg-zinc-800" />
          <PinDashboardDialog
            isDialogOpen={isDialogOpen}
            setIsDialogOpen={setIsDialogOpen}
            isLoading={isSectionCreationLoading}
            onChange={(e) => setValue(e.target.value)}
            value={value}
            title="Create Section"
            handleSubmit={handleSubmit}
            description="Enter a unique name for your new section"
          >
            <DropdownMenuItem
              onSelect={(event) => {
                event.preventDefault();
              }}
              className="justify-center rounded-md bg-indigo-500 text-white hover:bg-indigo-400 focus:text-white focus:bg-indigo-400"
            >
              New Section
            </DropdownMenuItem>
          </PinDashboardDialog>
        </DropdownMenuSubContent>
      </DropdownMenuPortal>
    </>
  );
};

export default PinDashboardSection;
